import '.a{display:flex;}.ssr-plugin'
import '.ak{align-items:stretch;}.ssr-plugin'
import '.g{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.cu{background:var(--shades-white);}.ssr-plugin'
import '.bv{flex-grow:1;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.az{max-width:77.5rem;}.ssr-plugin'
import '.dn{justify-content:stretch;}.ssr-plugin'
import '.do{position:sticky;}.ssr-plugin'
import '.ch{top:0;}.ssr-plugin'
import '.dp{z-index:10;}.ssr-plugin'
import '.dq{padding-block:1rem;}.ssr-plugin'
import '.dr{height:3rem;}.ssr-plugin'
import '.y{justify-content:space-between;}.ssr-plugin'
import '.ds{flex-wrap:wrap;}.ssr-plugin'
import '.dt{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.bi{margin-top:2rem;}.ssr-plugin'
import '.du{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a ak g b cu"
      >
        <div className="bv a c g b"
        >
          <div className="az a b dn do ch dp cu"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="dq dr a y c ds"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="dt a b ak bi du az"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
